const formatDateToIso = (date) => date.toISOString().slice(0, 10);
export default formatDateToIso;
